import React from 'react';
import { ChevronLeft } from 'styled-icons/feather/ChevronLeft';

function PrevIcon(props) {
  return (
    <ChevronLeft {...props} className={'icon'} />
  );
}

export default PrevIcon;
